var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestAlgorithm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52613",
    "data-name": "Group 52613",
    transform: "translate(-158 -738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18643",
    "data-name": "Rectangle 18643",
    transform: "translate(158 738)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_10_",
    "data-name": "svgexport-7 (10)",
    transform: "translate(168 748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90993",
    "data-name": "Path 90993",
    d: "M54,31H53V30a1,1,0,0,0-1-1H50a19.172,19.172,0,0,0,.557-2H53a1,1,0,0,0,1-1V20a1,1,0,0,0-1-1H50.557a18.691,18.691,0,0,0-2.6-6.3l1.725-1.725a1,1,0,0,0,0-1.414L45.435,5.322a1,1,0,0,0-1.414,0L42.3,7.047a18.751,18.751,0,0,0-6.3-2.6V2a1,1,0,0,0-1-1H29a1,1,0,0,0-1,1V4.442a18.751,18.751,0,0,0-6.3,2.6l-1.721-1.72a1.029,1.029,0,0,0-1.414,0L14.322,9.565a1,1,0,0,0,0,1.414L16.047,12.7a18.691,18.691,0,0,0-2.6,6.3H11a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h2.443A19.172,19.172,0,0,0,14,29H12a1,1,0,0,0-1,1v1H10a3,3,0,0,0-3,3V60a3,3,0,0,0,3,3H54a3,3,0,0,0,3-3V34A3,3,0,0,0,54,31ZM21.614,29a12,12,0,1,1,20.772,0h-2.34c.106-.174.207-.35.32-.522a10,10,0,1,0-16.718.022c.109.165.206.333.308.5Zm3.7-1.6A7.964,7.964,0,0,1,24,22.94,8,8,0,0,1,40,23a7.96,7.96,0,0,1-1.306,4.38A17.3,17.3,0,0,0,36.875,31H27.131a16.907,16.907,0,0,0-1.814-3.6ZM36.025,35h-8.05a14,14,0,0,0-.273-2h8.6A13.914,13.914,0,0,0,36.025,35Zm-.643,2-1,2H29.618l-1-2ZM33,41h2a1,1,0,0,0,.9-.553l2-4h-.01A.978.978,0,0,0,38,36v-.185A12.477,12.477,0,0,1,39.022,31H51V57H38.6A12.856,12.856,0,0,0,33,58.287ZM15.256,25.834A1,1,0,0,0,14.27,25H12V21h2.27a1,1,0,0,0,.986-.834,16.782,16.782,0,0,1,2.9-7,1,1,0,0,0-.107-1.287l-1.6-1.6L19.278,7.45l1.6,1.6a1,1,0,0,0,1.286.107,16.8,16.8,0,0,1,7-2.9A1,1,0,0,0,30,5.27V3h4V5.27a1,1,0,0,0,.834.986,16.8,16.8,0,0,1,7,2.9,1,1,0,0,0,1.286-.107l1.6-1.6,2.829,2.829-1.6,1.6a1,1,0,0,0-.107,1.287,16.782,16.782,0,0,1,2.9,7A1,1,0,0,0,49.73,21H52v4H49.73a1,1,0,0,0-.986.834A17.045,17.045,0,0,1,47.864,29H44.645a14,14,0,1,0-25.29,0H16.136a16.969,16.969,0,0,1-.88-3.166ZM13,31H24.984A12.467,12.467,0,0,1,26,35.813V36a.978.978,0,0,0,.115.443h-.01l2,4A1,1,0,0,0,29,41h2V58.287A12.856,12.856,0,0,0,25.4,57H13ZM55,60a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V34a1,1,0,0,1,1-1h1V58a1,1,0,0,0,1,1H25.4a10.878,10.878,0,0,1,6.05,1.832,1,1,0,0,0,1.11,0A10.878,10.878,0,0,1,38.6,59H52a1,1,0,0,0,1-1V33h1a1,1,0,0,1,1,1Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90994",
    "data-name": "Path 90994",
    d: "M15,43H27v2H15Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90995",
    "data-name": "Path 90995",
    d: "M17,39h8v2H17Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90996",
    "data-name": "Path 90996",
    d: "M39,39h8v2H39Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90997",
    "data-name": "Path 90997",
    d: "M15,47H27v2H15Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90998",
    "data-name": "Path 90998",
    d: "M15,51H27v2H15Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90999",
    "data-name": "Path 90999",
    d: "M37,43H49v2H37Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91000",
    "data-name": "Path 91000",
    d: "M37,47H49v2H37Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91001",
    "data-name": "Path 91001",
    d: "M37,51H49v2H37Z",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91002",
    "data-name": "Path 91002",
    d: "M36,23h2a6.006,6.006,0,0,0-6-6v2A4,4,0,0,1,36,23Z",
    fill: "#93a750"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestAlgorithm);
export default __webpack_public_path__ + "static/media/TestAlgorithm.2b83a727a999f6c6ce1536dc800d4a56.svg";
export { ForwardRef as ReactComponent };